import React from "react"
import { useSurveyScheduledReportExportContext } from "contexts/SurveyScheduledReportExportContext"
import LocationAnswerFiltersQuestionSelect from "./LocationAnswerFiltersQuestionSelect"
import LocationAnswerFiltersLocationDetails from "./LocationAnswerFiltersLocationDetails"

const NewSurveyScheduledReportExportFormLocationAnswerFilters = () => {
  const { locationAnswerFilters } = useSurveyScheduledReportExportContext()

  const locationAnswerFilter = locationAnswerFilters[0] ?? {}
  const { questionUuid } = locationAnswerFilter

  return (
    <div className="w-full">
      <LocationAnswerFiltersQuestionSelect />
      {
        questionUuid && (
          <LocationAnswerFiltersLocationDetails />
        )
      }
    </div>
  )
}

export default NewSurveyScheduledReportExportFormLocationAnswerFilters
